import React from 'react';
import PropTypes from 'prop-types';

import { Typography, makeStyles } from '@material-ui/core';

import Title from '../../Title';
import InfoCardList from '../../common/InfoCardList';
import InfoCard from '../../common/InfoCard';

const propTypes = {
    onSetFilter: PropTypes.func.isRequired,
    filter: PropTypes.string,
    applications: PropTypes.array
};

const defaultProps = {
    filter: undefined,
    applications: undefined
};

const useStyles = makeStyles((theme) => style(theme));

function PlanningInfoCardList ({ onSetFilter, filter, applications }) {
    const classes = useStyles();

    const isLoading = !Boolean(applications);

    const granted = applications && applications.filter(e => e.appStateAggregateV2 === 'granted').length;
    const pending = applications && applications.filter(e => e.appStateAggregateV2 === 'pending').length;
    const refused = applications && applications.filter(e => e.appStateAggregateV2 === 'refused').length;
    const withdrawn = applications && applications.filter(e => e.appStateAggregateV2 === 'withdrawn').length;

    return (
        <>
            <Title
                title="PLANNING APPLICATIONS"
                skeleton={isLoading}
            />
            <InfoCardList>
                <InfoCard
                    skeleton={isLoading}
                    active={!filter}
                    inline
                    onClick={() => onSetFilter(null)}
                >
                    <Typography>
                        All time
                    </Typography>
                    <Typography>
                        {applications && applications.length}
                    </Typography>
                </InfoCard>
            </InfoCardList>
            <InfoCardList>
                <InfoCard
                    grow={2}
                    skeleton={isLoading}
                    active={filter === 'granted'}
                    onClick={() => onSetFilter('granted')}
                >
                    <Typography>
                        Granted
                    </Typography>
                    <Typography>
                        <svg className={classes.granted} />
                        {granted}
                    </Typography>
                </InfoCard>
                <InfoCard
                    grow={2}
                    skeleton={isLoading}
                    active={filter === 'pending'}
                    onClick={() => onSetFilter('pending')}
                >
                    <Typography>
                        Pending
                    </Typography>
                    <Typography>
                        <svg className={classes.pending} />
                        {pending}
                    </Typography>
                </InfoCard>
                <InfoCard
                    grow={2}
                    skeleton={isLoading}
                    active={filter === 'refused'}
                    onClick={() => onSetFilter('refused')}
                >
                    <Typography>
                        Refused
                    </Typography>
                    <Typography>
                        <svg className={classes.refused} />
                        {refused}
                    </Typography>
                </InfoCard>
                <InfoCard
                    grow={2}
                    skeleton={isLoading}
                    active={filter === 'withdrawn'}
                    onClick={() => onSetFilter('withdrawn')}
                >
                    <Typography>
                        Withdrawn
                    </Typography>
                    <Typography>
                        <svg className={classes.withdrawn} />
                        {withdrawn}
                    </Typography>
                </InfoCard>
            </InfoCardList>
        </>
    );
}

const style = theme => ({
    root: {
        display: 'flex',
        '&> *': {
            flex: '1 1 0',
            '&:not(:last-child)': {
                marginRight: theme.constants.horizontalMargin
            }
        }
    },
    granted: {
        background: '#0217fa',
        borderRadius: '1em',
        border: '2px solid white',
        width: 16,
        height: 16,
    },
    pending: {
        background: '#6dd0f2',
        borderRadius: '1em',
        border: '2px solid white',
        width: 16,
        height: 16,
    },
    refused: {
        background: '#fdae61',
        borderRadius: '1em',
        border: '2px solid white',
        width: 16,
        height: 16,
    },
    withdrawn: {
        background: '#f7686a',
        borderRadius: '1em',
        border: '2px solid white',
        width: 16,
        height: 16,
    }
});

PlanningInfoCardList.propTypes = propTypes;
PlanningInfoCardList.defaultProps = defaultProps;

export default PlanningInfoCardList;